import { http } from "./client";
import type { WorkspaceAccessSession } from "@/types/domain";

type SessionPage = { items: WorkspaceAccessSession[]; page: { total: number; total_pages: number } };

// Requirement 5 of strict Super Admin tenant isolation - every workspace a
// Super Admin opens is recorded with who, which workspace, when, why, and
// for how long. See backend/internal/service/workspaceaccess.go.
export const workspaceAccessApi = {
  enter: (tenantId: string, reason: string) =>
    http.post<WorkspaceAccessSession>(`/tenants/${tenantId}/workspace-access`, { reason }),

  exit: (sessionId: string) => http.post<{ exited: boolean }>(`/workspace-access/${sessionId}/exit`),

  list: (filters: { tenant_id?: string; per_page?: number } = {}) =>
    http.get<SessionPage>("/platform/workspace-access", filters),
};
